import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import FaqChat from '~/components/Layout/FaqChat.vue';
export default {
  __name: 'FaqChatTrigger',
  setup: function setup(__props) {
    var faqChat = ref();
    var _useIsFaq = useIsFaq(),
      isFaqPage = _useIsFaq.isFaqPage;
    return {
      __sfc: true,
      faqChat: faqChat,
      isFaqPage: isFaqPage,
      AzIcon: AzIcon,
      FaqChat: FaqChat
    };
  }
};